import Vue from 'vue'
import Vuex from 'vuex'

import texts from './texts'
import dropdowns from './dropdowns'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    form: {
      car: {
        model: {
          value: "",
          name: "Novi Xtrail",
          image: "",
        },
        vin: "",
        year: ""
      },
      user: {
        title: '',
        name: '',
        last_name: '',
        email: '',
        //telephone: ''
      },
      /*gdpr: {
        //eNews: false,
        //purchase: ''
        ePosta: false,
        telefon: false,
        sms: false
      },*/
      formName: "LF-N-OstaniteZNami-Nissan-Xtrail"
    },
    // VALIDATION
    validation: {
      title: false,
      name: false,
      lastName: false,
      email: false,
      //telephone: true
    },
    buttons: {
      /*purchase: {
        value: null,
        error: false
      }*/
      ePosta: {
        value: null,
        error: false
      },
      /*telefon: {
        value: null,
        error: false
      },
      sms: {
        value: null,
        error: false
      }*/
    },
    submitted: false,
    DisclosureOneOpened: false
  },
  getters: {
    name: state => {
      return state.form.user.name
    },
    last_name: state => {
      return state.form.user.last_name
    },
    email: state => {
      return state.form.user.email
    },
    /*telephone: state => {
      return state.form.user.telephone
    },*/
  },
  mutations: {
    updateName: (state, data) => {
      state.form.user.name = data
    },
    updateLastName: (state, data) => {
      state.form.user.last_name = data
    },
    updateEmail: (state, data) => {
      state.form.user.email = data
    },
    /*updateTelephone: (state, data) => {
      state.form.user.telephone = data
    },*/
  },
  modules: {
    dropdowns,
    texts
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js